import React from 'react';

/*eslint-disable */
var arrowKeysUpSelected = (function (_ref) {
  var alt = _ref.alt;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, alt), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: '#282B3E'
    },
    d: "M7.08 6.137v1.92h-.001l.001 3.84H5.16l-.001-3.84H1.32v-1.92h5.76z",
    transform: "translate(-544 -234) translate(350 218) translate(194 16) rotate(-180 8.1 9.3) rotate(135 4.2 9.017)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: '#C2C3C9'
    },
    d: "M7.08 7.073H5.16l-.001-3.841H1.32v-1.92h5.76v5.76z",
    transform: "translate(-544 -234) translate(350 218) translate(194 16) rotate(-180 8.1 9.3) rotate(-45 4.2 4.193)"
  })));
});

export { arrowKeysUpSelected as default };
